import { ZodSchema, z } from 'zod';

/**
 * Схема паллеты
 */
const palletParametersSchema = z.object({
  type: z.string(),
  quantity: z.number(),
  weight: z.number(),
});

/**
 * Схема фуры
 */
const truckParametersSchema = z.object({
  truckId: z.union([z.string(), z.number(), z.null()]),
  truckQuantity: z.number(),
  eachTruckWeight: z.number().nullable(),
  withPallets: z.boolean(),
  palletsLoaded: z.array(palletParametersSchema),
});

const truckParametersIndexSchema = z.object({
  truckParameters: z.array(truckParametersSchema),
  isCustomConditionsOpen: z.boolean(),
  isDangerousCargo: z.boolean(),
  targetCurrencyId: z.string(),
});

/**
 * Схема контейнера
 */
const containerParametersSchema = z.object({
  containerId: z.union([z.string(), z.number(), z.null()]),
  containerType: z.string(),
  containerQuantity: z.number(),
  eachContainerWeight: z.number().nullable(),
  withPallets: z.boolean(),
  palletsLoaded: z.array(palletParametersSchema),
});

const containerParametersIndexSchema = z.object({
  containerParameters: z.array(containerParametersSchema),
  isCustomConditionsOpen: z.boolean(),
  isDangerousCargo: z.boolean(),
  targetCurrencyId: z.string(),
});

/**
 * Схема сборных грузов
 */
const customCargoBaseParametersSchema = z.object({
  quantity: z.number(),
  length: z.string(),
  width: z.string(),
  height: z.string(),
  weight: z.string(),
});

const customCargoPalletParametersSchema = z.object({
  type: z.string(),
  quantity: z.number(),
  normativeHeightOfStacking: z.string(),
  weight: z.number(),
});

const customCargoVolumeParametersSchema = z.object({
  volume: z.string(),
  weight: z.string(),
  height: z.number(),
});

const transportTypeSchema = z.object({
  type: z.union([z.literal('container'), z.literal('truck')]),
  transportTypeId: z.number(),
  weight: z.number(),
});

const customCargoParametersSchema = z.object({
  parametersType: z.union([z.literal('base'), z.literal('pallet'), z.literal('volume')]),
  parametersCargoCalcType: z.union([z.literal('base'), z.literal('volume')]),
  baseParameters: customCargoBaseParametersSchema,
  palletParameters: customCargoPalletParametersSchema,
  volumeParameters: customCargoVolumeParametersSchema,
});

const customCargoParametersIndexSchema = z.object({
  customCargoParameters: z.array(customCargoParametersSchema),
  isCustomConditionsOpen: z.boolean(),
  isDangerousCargo: z.boolean(),
  targetCurrencyId: z.string(),
  cargoFingerprint: z.string(),
  transportTypes: z.array(transportTypeSchema),
});

/**
 * Схема ветки локаций
 */

const branchItemSchema = z.object({
  id: z.string(),
  parentId: z.string().nullable(),
  type: z.string(),
  isWarehouse: z.boolean().optional(),
  main: z.boolean().optional(),
  visibleName: z.string(),
});

/**
 * Схема типов грузоперевозок
 */
const cargoTypeSchema = z.union([
  z.literal('container'),
  z.literal('custom'),
  z.literal('auto'),
  z.literal('air'),
  z.literal('fclFtl'),
]);

/**
 * Схема параметров для расчета
 */
export const routeParamsSchemas: Record<string, ZodSchema> = {
  cargoType: cargoTypeSchema.optional(),
  containerParameters: containerParametersIndexSchema.optional(),
  customCargoParameters: customCargoParametersIndexSchema.optional(),
  truckParameters: truckParametersIndexSchema.optional(),
  startLocation: branchItemSchema.optional(),
  endLocation: branchItemSchema.optional(),
  startExpeditionDate: z.date().optional(),
  startTransportingCondition: z.string(),
  endTransportingCondition: z.string(),
  isNeedPrekeridge: z.boolean(),
  isNeedContainerRent: z.boolean(),
  isFromTerminalRadius: z.boolean(),
  isToTerminalRadius: z.boolean(),
  isWithoutOnkeridge: z.boolean(),
  isWithoutPrekeridge: z.boolean(),
  isWithCrossDocking: z.boolean(),
  requiredTransportingTypes: z.array(z.number()),
};
